/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

/**
 * Filter criteria for searching chat sessions
 */
export type SearchChatsFilter = {
  /**
   * Deployment ID filter
   */
  deploymentId?: string | undefined;
  /**
   * External user ID filter
   */
  externalUserId?: string | undefined;
  /**
   * Start time in ISO 8601 format (e.g., '2025-12-19T10:00:00Z')
   */
  from?: Date | undefined;
  /**
   * Speakeasy URN filter (single URN, use gram_urns for multiple)
   */
  gramUrn?: string | undefined;
  /**
   * End time in ISO 8601 format (e.g., '2025-12-19T11:00:00Z')
   */
  to?: Date | undefined;
  /**
   * User ID filter
   */
  userId?: string | undefined;
};

/** @internal */
export type SearchChatsFilter$Outbound = {
  deployment_id?: string | undefined;
  external_user_id?: string | undefined;
  from?: string | undefined;
  gram_urn?: string | undefined;
  to?: string | undefined;
  user_id?: string | undefined;
};

/** @internal */
export const SearchChatsFilter$outboundSchema: z.ZodMiniType<
  SearchChatsFilter$Outbound,
  SearchChatsFilter
> = z.pipe(
  z.object({
    deploymentId: z.optional(z.string()),
    externalUserId: z.optional(z.string()),
    from: z.optional(z.pipe(z.date(), z.transform(v => v.toISOString()))),
    gramUrn: z.optional(z.string()),
    to: z.optional(z.pipe(z.date(), z.transform(v => v.toISOString()))),
    userId: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      deploymentId: "deployment_id",
      externalUserId: "external_user_id",
      gramUrn: "gram_urn",
      userId: "user_id",
    });
  }),
);

export function searchChatsFilterToJSON(
  searchChatsFilter: SearchChatsFilter,
): string {
  return JSON.stringify(
    SearchChatsFilter$outboundSchema.parse(searchChatsFilter),
  );
}
